<template>
  <div class="materials-subscription">
    <h3 class="materials-subscription__title">
      подписывайтесь на&nbsp;обновления, <span>чтобы не&nbsp;пропустить</span>
    </h3>
    <p class="materials-subscription__text">
      новостной дайджест: статьи, видео, подкасты с&nbsp;советами по&nbsp;выбору
      курсов, подготовке к&nbsp;экзаменам и&nbsp;развитию навыков
    </p>
    <div class="materials-subscription__form">
      <form-email-field
        ref="emailField"
        v-model="emailInput"
        class="materials-subscription__form_input"
        round-border
        placeholder="ваша почта"
      />
      <!-- eslint-disable -->
      <p class="materials-subscription__law">
        нажимая на кнопку, вы соглашаетесь
        с&nbsp;<nuxt-link
        to="/privacy"
        target="_blank"
      >условиями обработки данных</nuxt-link>
        в&nbsp;соответствии
        с&nbsp;<nuxt-link
        to="/privacy"
        target="_blank"
      >политикой конфиденциальности</nuxt-link>
      </p>
      <!-- eslint-enable -->
      <button
        class="m-btn"
        @click="subscribe"
      >
        подписаться
      </button>
    </div>
  </div>
</template>
<script>
import FormEmailField from '~/components/v2/common/fileds/FormEmailField.vue';

export default {
  name: 'MaterialsSubscription',
  components: { FormEmailField },

  data: () => ({
    emailInput: null,
  }),

  methods: {
    async subscribe() {
      if (!this.$refs.emailField.validate()) {
        return;
      }

      const response = await this.$api.emailSubscribe(this.emailInput);

      if (response.success) {
        this.emailInput = '';
        this.$refs.emailField.reset();

        this.$notify({
          duration: 10000,
          text: 'Вы успешно подписаны на&nbsp;обновления',
          type: 'success',
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .materials-subscription {
    position: relative;
    height: calc(var(--scale) * 350);
    padding: calc(var(--scale) * 16) calc(var(--scale) * 40) calc(var(--scale) * 40);
    border-radius: calc(var(--scale) * 60);

    background-image: url("/img/materials/subscription/bg.webp");
    background-size: 100% 100%;

    @include media-down($size-tablet) {
      display: flex;
      justify-content: space-between;
      height: calc(var(--scale) * 314);
      padding: calc(var(--scale) * 20) calc(var(--scale) * 8) calc(var(--scale) * 8) calc(var(--scale) * 16);
      border-radius: calc(var(--scale) * 32);
      background-image: url("/img/materials/subscription/bg-tablet.webp");
    }

    @include media-down($size-mobile) {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      height: calc(var(--scale) * 574);
      padding: calc(var(--scale) * 16) calc(var(--scale) * 8) calc(var(--scale) * 8);
      background-image: url("/img/materials/subscription/bg-mob.webp");
    }

    &__title {
      margin-bottom: calc(var(--scale) * 23);
      max-width: calc(var(--scale) * 716);

      font-weight: 500;
      font-size: calc(var(--scale) * 64);
      line-height: 95%;
      letter-spacing: -0.02em;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        margin-bottom: calc(var(--scale) * 12);
        max-width: calc(var(--scale) * 333);
        font-size: calc(var(--scale) * 44);
        line-height: 90%;
        letter-spacing: -0.06em;
      }

      @include media-down($size-mobile) {
        padding-inline: calc(var(--scale) * 8);
      }

      span {
        color: #CEF9FF;
      }
    }

    &__text {
      max-width: calc(var(--scale) * 558);
      position: absolute;
      right: calc(var(--scale) * 40);
      top: calc(var(--scale) * 32);

      font-weight: 500;
      font-size: calc(var(--scale) * 32);
      line-height: 110%;
      text-align: right;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        max-width: calc(var(--scale) * 334);
        left: calc(var(--scale) * 16);
        top: auto;
        bottom: calc(var(--scale) * 34);

        font-size: calc(var(--scale) * 18);
        line-height: 120%;
        text-align: left;
      }

      @include media-down($size-mobile) {
        position: static;
        padding-inline: calc(var(--scale) * 8);
      }
    }

    &__form {
      display: flex;
      align-items: center;
      gap: calc(var(--scale) * 10);

      @include media-down($size-tablet) {
        flex-direction: column;
        gap: calc(var(--scale) * 20);
      }

      @include media-down($size-mobile) {
        margin-top: auto;
      }

      &_input ::v-deep(input) {
        width: calc(var(--scale) * 466);
        height: calc(var(--scale) * 88);
        padding-inline: calc(var(--scale) * 40);
        border: none;

        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: #02120F;

        @include media-down($size-tablet) {
          padding-inline: calc(var(--scale) * 24);
          width: calc(var(--scale) * 334);
          height: calc(var(--scale) * 68);
          border: 1px solid rgba(167, 171, 172, 0.5);
          border-radius: calc(var(--scale) * 200);

          font-size: calc(var(--scale) * 18);
          line-height: 110%;
          letter-spacing: -0.02em;
        }

        &::placeholder {
          color: #A7ABAC;
        }
      }

      button {
        height: calc(var(--scale) * 88);
        padding-inline: calc(var(--scale) * 40);
        background-color: #FF5319;
        border-radius: calc(var(--scale) * 200);
        transition: 200ms;

        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: #FFFFFF;

        @include media-down($size-tablet) {
          margin-top: auto;
          padding-inline: calc(var(--scale) * 109);
          height: calc(var(--scale) * 80);
          box-shadow:
            calc(var(--scale) * 10) calc(var(--scale) * 10) calc(var(--scale) * 50) rgba(7, 21, 57, 0.1),
            calc(var(--scale) * 4) calc(var(--scale) * 4) calc(var(--scale) * 20) rgba(7, 21, 57, 0.05);
          border-radius: calc(var(--scale) * 24);
          font-size: calc(var(--scale) * 22);
        }

        @media (hover: hover) {
          &:hover {
            background-color: #FF9C12;
          }
        }
      }
    }

    &__law {
      position: absolute;
      max-width: calc(var(--scale) * 415);
      bottom: calc(var(--scale) * 40);
      right: calc(var(--scale) * 40);

      font-weight: 500;
      font-size: calc(var(--scale) * 16);
      line-height: 130%;
      text-align: right;
      color: rgba(255, 255, 255, 0.5);

      @include media-down($size-tablet) {
        position: static;
        max-width: calc(var(--scale) * 334);
        font-size: calc(var(--scale) * 14);
      }

      @include media-down($size-mobile) {
        max-width: 100%;
        margin-bottom: calc(var(--scale) * 8);
        padding-inline: calc(var(--scale) * 8);
        text-align: left;
      }

      a {
        color: #0A4183;
        text-decoration: underline;
      }
    }
  }
</style>
